import React from "react";
import colors from "../../../sass/brand_palette.scss";
import StarRatings from "./StarsRating";
import styled from "@emotion/styled";
import withTranslator from "../Translator/withTranslation";
import { compose } from "recompose";

const StarRatingContainer = styled.div`
    background:rgba(0,0,0,.2);
`;


const VillaRatingComponent = (props) => {
    const { data, t }  = props;

    const rating = () => {
        var numberStars = 5,
            starRate = parseInt(10/numberStars),
            cvRating = parseFloat(parseFloat(data.cvInternalReviewScore/starRate).toFixed(1)),
            villaRating = parseFloat(parseFloat(data.reviewScore/starRate).toFixed(1)),
            starStyle = {
                fontSize: '1.2em',
                margin: '0 .25rem'
            };
        if(data.reviews.length === 0) {
            if ((data.cvInternalReviewScore > 0 && !isNaN(cvRating)) || data.reviewScore > 0 && !isNaN(villaRating)) {
                return (
                    <StarRatingContainer className="px-2 border-radius-default">
                        <StarRatings
                            rating={villaRating ? villaRating : cvRating}
                            starRatedColor={colors.orange2}
                            starEmptyColor={colors.grey3}
                            numberOfStars={5}
                            name={t('reviews')}
                            starDimension="17px"
                            starSpacing="4px"  
                            fillId={data.name+data.id}
                        />  
                        {villaRating ? 
                            <div className="font-80">{parseFloat(data.reviewScore).toFixed(1)} / 10 | {data.reviewCount} {t('reviews')}</div>
                            :
                            <div className="font-80">{t('cv_internal_review_score')}</div>
                        }
                        <style dangerouslySetInnerHTML={{__html: `
                            .star-ratings .star-container .widget-svg{vertical-align:middle}
                        `}} />
                    </StarRatingContainer>
                );
            } else {
                return null;
            }
        }
        
        if(props.reviewType === 'stars' && !isNaN(villaRating)){
            if ((data.reviewScore.toFixed(1) >= 8 && data.reviews.length == 1) || data.reviews.length > 1 ) {
                return (
                    <StarRatingContainer className="px-2 border-radius-default">
                        <StarRatings
                            rating={villaRating ? villaRating : cvRating}
                            starRatedColor={colors.orange2}
                            starEmptyColor={colors.grey3}
                            numberOfStars={5}
                            name={t('reviews')}
                            starDimension="17px"
                            starSpacing="4px"  
                            fillId={data.name+data.id}
                        />
                        {props.reviewStarText ?
                        <div className="font-80">{data.reviewScore.toFixed(1)} / 10 | {data.reviews.length} {t('reviews')}</div>
                        :''}
                        <style dangerouslySetInnerHTML={{__html: `
                            .star-ratings .star-container .widget-svg{vertical-align:middle}
                        `}} />
                    </StarRatingContainer>
                );
            }
        } else {
            return (
                <div className="bg-green1 px-2 border-radius-default">
                    <span className="font-w600">{data.reviewScore.toFixed(1)} / 10</span> | {data.reviews.length} {t('reviews')}
                </div>
            );
        }
    }
    
    return (
        <div className={props.className}>
            {rating()}
        </div>
    );
}

export const VillaRating = compose(
    withTranslator,
    React.memo)(VillaRatingComponent);